import api from "@beeldit/core/helpers/api";

function login(loginData: any, onSuccess: any) {
  const login = async (loginData: any) => {
    try {
      const response = await api.post("/login", loginData);
      onSuccess(response.data);
      console.log(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  login(loginData);
}

export default login;
